import {ChangeDetectionStrategy, Component, Injector, Input, ViewChild} from '@angular/core'
import {
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  FormControlDirective,
  NG_VALUE_ACCESSOR, ReactiveFormsModule
} from '@angular/forms'
import {Backend} from "@generated-backend-types";
import {TranslateService} from "@ngx-translate/core";
import CountryCodeISOAlpha3Enum = Backend.App.Enums.CountryCodeISOAlpha3Enum;
import {CoreModule} from "../../../../core.module";
import {TooltipModule} from "ngx-bootstrap/tooltip";import {
  MultiSelectWithStaticOptionsStaticComponent
} from "../multi-select-static-with-static-options/multi-select-with-static-options-static.component";
import {SelectOption} from "../form-group/form-group.component";
import {distinctUntilChanged} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";


@Component({
    selector: 'app-country-selector',
    templateUrl: './country-selector.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: CountrySelectorComponent,
            multi: true
        }],
    imports: [CoreModule, ReactiveFormsModule, TooltipModule, MultiSelectWithStaticOptionsStaticComponent],
    standalone: true
})
export class CountrySelectorComponent implements ControlValueAccessor {

  @Input() public label!: string
  @Input() public small = false

  @Input() public errorMessages!: Record<string, string>
  @Input() public name!: string
  @Input() public inline = false

  @Input() public prefix?: string


  @Input() public tooltipText?: string
  @Input() public inputCounter = false
  @Input() public minRows = 3
  @Input() public inputCounterMax: number | null = null
  @Input() public placeholder?: string;

  public selectOptions: SelectOption[] = [];

  /**
   * @see https://github.com/nileshpatel17/ng-multiselect-dropdown#settings
   */


  @ViewChild(FormControlDirective, {static: true})
  public formControlDirective?: FormControlDirective;

  @Input()
  public formControl?: FormControl;

  @Input()
  public formControlName!: string;

  public get control(): FormControl {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return <FormControl>this.formControl ?? this.controlContainer.control.get(this.formControlName);
  }

  get controlContainer(): ControlContainer {
    return this.injector.get(ControlContainer);
  }

  registerOnTouched(fn: () => void): void {
    this.formControlDirective?.valueAccessor?.registerOnTouched(fn);
  }

  registerOnChange(fn: () => void): void {
    this.formControlDirective?.valueAccessor?.registerOnChange(fn);
  }

  writeValue(fn: () => void): void {
    this.formControlDirective?.valueAccessor?.writeValue(fn);
  }

  setDisabledState(): void {
    // da formControl und control identisch sind brauchen wir hier nichts weiter zu geben

  }

  private setSelectOptions(): void {
    const list = Object.values(CountryCodeISOAlpha3Enum).map(
      code => {
        return {key: code as string, value: this.translateService.instant('enums.countryCodeISOAlpha3Enum.' + code)}
      }
    );

    let sortedList = [...list].sort((a, b) => {
      if (typeof a.value === 'string' && typeof b.value === 'string') {
        return (a.value as string).localeCompare(b.value)
      }
      if (a.value < b.value) {
        return -1;
      }
      if (a.value > b.value) {
        return 1;
      }
      return 0;
    })

    sortedList = sortedList.filter(item => !['DEU', 'AUT', 'CHE'].includes(item.key))

    this.selectOptions = [
      {key: 'DEU', value: this.translateService.instant('enums.countryCodeISOAlpha3Enum.DEU')},
      {key: 'AUT', value: this.translateService.instant('enums.countryCodeISOAlpha3Enum.AUT')},
      {key: 'CHE', value: this.translateService.instant('enums.countryCodeISOAlpha3Enum.CHE')},
      ...sortedList
    ]
  }

  constructor(private readonly injector: Injector,
              private readonly translateService: TranslateService
  ) {
    this.translateService.onLangChange.pipe(
      distinctUntilChanged(),
      takeUntilDestroyed()
    ).subscribe(() => this.setSelectOptions())

    this.setSelectOptions();
  }
}
